/* globals google */

var formValidation = require('base/components/formValidation');

function getCookieByName(name) {
    const cookieString = document.cookie;
    const cookies = cookieString.split(';');

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();

        if (cookie.startsWith(`${name}=`)) {
            return cookie.substring(name.length + 1);
        }
    }

    return null;
}

function setGeolocation(isAllowed, position) {
    const allowedCookieName = 'isGeolocationAllowed';
    const geolocationCookieName = 'customerGeolocation';
    const previousCookieValue = getCookieByName(allowedCookieName);

    document.cookie = `${allowedCookieName}=${isAllowed}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;

    if (isAllowed && position && position.coords) {
        const customerGeolocation = `${position.coords.latitude}#${position.coords.longitude}`;
        document.cookie = `${geolocationCookieName}=${customerGeolocation}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
    } else {
        document.cookie = `${geolocationCookieName}=; expires=Fri, 01 Jan 1970 00:00:00 GMT; path=/`;
    }

    if (previousCookieValue !== isAllowed) {
        window.location.reload();
    }
}

/**
 * Check if geolocation permission cookie exists, if not request permission and set cookie
 */
function checkGeolocationPermission() {
    const url = $('#setGeolocationPermissionUrl').val();
    if (!url) {
        return;
    }

    if (navigator.geolocation) {
        // Request geolocation permission
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                setGeolocation('true', pos);
            },
            () => {
                setGeolocation('false');
            },
        );
    } else {
        setGeolocation('false');
    }
}

// Function to update Add to Cart button based on selected delivery method availability
function updateAddToCartBasedOnDeliveryMethod() {
    if ($('.product-detail').length > 0 && $('.delivery-option-card').length > 0) {
        const $selectedMethod = $('input[name="deliveryMethod"]:checked');
        const $addToCartButton = $('.add-to-cart');
        const isAvailable = $selectedMethod.data('available');

        $addToCartButton.prop('disabled', !isAvailable);
        if (isAvailable) {
            $addToCartButton.removeClass('add-to-cart-delivery-unavailable');
        } else {
            $addToCartButton.addClass('add-to-cart-delivery-unavailable');
        }
    }
}

function getDeliveryOptionsRequiredData(serializedData, separator) {
    const pid = $('.product-detail:not(".bundle-item")').data('pid') || '';
    const isAutoship = $('.product-type-option').length > 0 && $('.product-type-option:checked').hasClass('autoship-option');
    const $pdpAutoshipFrequencySelected = $('select.js--autoshipFrequency').find('option:selected');
    const quantity = $('.quantity-select').val();
    const isCartPage = $('.cart-page').length > 0;

    let autoshipFrequency = null;
    if ($pdpAutoshipFrequencySelected.length) {
        autoshipFrequency = $pdpAutoshipFrequencySelected.val();
    }

    const isPickup = $('#deliveryMethod-pickup').is(':checked');

    var data = {
        pid,
        isAutoship,
        autoshipFrequency,
        quantity,
        isPickup,
        isCartPage,
    };

    if (serializedData) {
        if (serializedData.indexOf('quantity') > -1) {
            delete data.quantity;
        }
        if (serializedData.indexOf('pid') > -1) {
            delete data.pid;
        }

        return `${separator || '?'}${new URLSearchParams(data)}`;
    }

    return data;
}

function handleAlertAddressMessage(message, selector, show) {
    const $el = $('.feedback-message', selector);

    $('.error-message', $el).text(message || '');

    if (show) {
        $el.removeClass('d-none');
    } else {
        $el.addClass('d-none');
    }
}

$(document).ready(() => {
    // Check geolocation permission on page load
    checkGeolocationPermission();

    $('.delivery-address-modal-link').on('click', (e) => {
        e.preventDefault();
        $.spinner().start();

        $.ajax({
            url: e.currentTarget.href,
            type: 'GET',
            dataType: 'html',
            success(data) {
                $('#deliveryAddressModal .modal-content').html(data);
                $('#deliveryAddressModal').modal('show');
                $.spinner().stop();
            },
            error(err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $.spinner().stop();
            },
        });

        e.stopPropagation();
    });

    $('body').on('submit', '#selectAddressForm', (e) => {
        e.preventDefault();
        const $form = $('#selectAddressForm');
        const selectedAddress = $('input[name=address]:checked', '#selectAddressForm').val();
        const submitButton = $form.find('.select-address-button');

        if (!submitButton.prop('disabled') && selectedAddress) {
            submitButton.prop('disabled', true);

            $('#deliveryAddressModal').spinner().start();

            const requestData = getDeliveryOptionsRequiredData();
            requestData.addressId = selectedAddress;

            $.ajax({
                url: $form.attr('action'),
                type: 'POST',
                dataType: 'json',
                data: requestData,
                success(data) {
                    if (data.success) {
                        if ($('.cart-page').length > 0 || $('.delivery-selected-zipcode').attr('data-target') === '#deliveryOptionModal' || $('.delivery-address-modal-link').length > 0) {
                            window.location.reload();
                            return;
                        }

                        $('#deliveryAddressModal').modal('hide');
                        $('.delivery-selected-zipcode', '.navbar-header').text(data.postalCode);
                        $('.delivery-selected-zipcode', '.delivery-options').text(data.addressId);

                        if (data.deliveryOptions) {
                            $('body').trigger('delivery:updated', data.deliveryOptions);
                        }
                    } else if (data.errorMessage) {
                        handleAlertAddressMessage(data.errorMessage, '#selectAddressForm', true);
                        submitButton.prop('disabled', false);
                    }

                    $('#deliveryAddressModal').spinner().stop();
                },
                error(err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $('#deliveryAddressModal').spinner().stop();
                },
            });
        }
    });

    $('body').on('submit', '#editAddressForm', (e) => {
        e.preventDefault();
        const $form = $('#editAddressForm');
        const submitButton = $form.find('.submit-address-button');

        if (!submitButton.prop('disabled')) {
            submitButton.prop('disabled', true);

            $('#deliveryAddressModal').spinner().start();
            handleAlertAddressMessage('', '#editAddressForm', false);

            let formData = $form.serialize();
            formData += getDeliveryOptionsRequiredData(formData, '&');

            $.ajax({
                url: $form.attr('action'),
                type: 'POST',
                dataType: 'json',
                data: formData,
                success(data) {
                    if (data.success) {
                        if ($('.cart-page').length > 0 || $('.delivery-selected-zipcode').attr('data-target') === '#deliveryOptionModal' || $('.delivery-address-modal-link').length > 0) {
                            window.location.reload();
                        } else {
                            $('#deliveryAddressModal').spinner().stop();
                            $('#deliveryAddressModal').modal('hide');
                            $('.delivery-selected-zipcode', '.navbar-header').text(data.postalCode);
                            $('.delivery-selected-zipcode', '.delivery-options').text(data.addressId);

                            if (data.deliveryOptions) {
                                $('body').trigger('delivery:updated', data.deliveryOptions);
                            }
                        }
                    } else {
                        $('#deliveryAddressModal').spinner().stop();
                        formValidation($form, data);

                        submitButton.prop('disabled', false);

                        if (data.errorMessage) {
                            handleAlertAddressMessage(data.errorMessage, '#editAddressForm', true);
                        }
                    }
                },
                error(err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        handleAlertAddressMessage(err.responseJSON.errorMessage, '#editAddressForm', true);
                    }
                    $('#deliveryAddressModal').spinner().stop();
                },
            });
        }
    });

    $('body').on('click', '.update-address', (e) => {
        e.preventDefault();
        $('#editAddressForm').trigger('reset');
        $('.edit-address-wrapper', '#deliveryAddressModal').removeClass('d-none');
        $('.select-address-wrapper', '#deliveryAddressModal').addClass('d-none');
        $('.title-select-address', '#deliveryAddressModal').addClass('d-none');
        $('.title-add-address', '#deliveryAddressModal').addClass('d-none');
        $('.title-edit-address', '#deliveryAddressModal').removeClass('d-none');

        const address = JSON.parse(e.currentTarget.dataset.address);
        $('#editAddressForm input[name="addressId"]').val(address.ID);
        $('#editAddressForm input[autocomplete="shipping shipping-name"]').val(address.ID);
        $('#editAddressForm input[autocomplete="shipping given-name"]').val(address.firstName);
        $('#editAddressForm input[autocomplete="shipping family-name"]').val(address.lastName);
        $('#editAddressForm input[autocomplete="shipping address-line1"]').val(address.address1);
        $('#editAddressForm input[autocomplete="shipping address-line2"]').val(address.address2);
        $('#editAddressForm input[autocomplete="shipping address-level2"]').val(address.city);
        $('#editAddressForm input[autocomplete="shipping postal-code"]').val(address.postalCode);
        $(`#editAddressForm select[autocomplete="shipping address-level1"] option[value="${address.stateCode}"]`).prop('selected', true);
    });

    $('body').on('click', '#deliveryAddressModal .remove-address', (e) => {
        e.preventDefault();
        const $addressCard = $(e.currentTarget).closest('.address-card');
        const { addressId } = e.currentTarget.dataset;
        $('#deliveryAddressModal').spinner().start();

        $.ajax({
            url: e.currentTarget.href,
            type: 'POST',
            data: { addressId },
            dataType: 'json',
            success(data) {
                if (data.success) {
                    $addressCard.remove();
                }
                $('#deliveryAddressModal').spinner().stop();
            },
            error(err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $('#deliveryAddressModal').spinner().stop();
            },
        });
    });

    $('body').on('click', '#addressModalUseMyLocation', () => {
        var $spinner = $('#deliveryAddressModal').length > 0 && $('#deliveryAddressModal').is(':visible')
            ? $('#deliveryAddressModal').spinner()
            : $.spinner();
        $spinner.start();

        if (!navigator.geolocation) {
            $spinner.stop();
            return;
        }

        var geocoder = new google.maps.Geocoder();

        navigator.geolocation.getCurrentPosition(
            (pos) => {
                var latlng = {
                    lat: pos.coords.latitude,
                    lng: pos.coords.longitude,
                };

                geocoder.geocode({ location: latlng }, (results, status) => {
                    $spinner.stop();
                    if (status === 'OK' && results[0]) {
                        var components = results[0].address_components;
                        var getObjParam = function (type, shortname) {
                            var comp = components.find((c) => c.types.includes(type));
                            if (comp) return shortname ? comp.short_name : comp.long_name;
                            return '';
                        };

                        if (getObjParam('country', true) !== 'US') {
                            return;
                        }

                        $('input[autocomplete="shipping address-line1"]').val(`${getObjParam('route')} ${getObjParam('street_number')}`);
                        $('input[autocomplete="shipping address-line2"]').val(getObjParam('neighborhood') || getObjParam('sublocality_level_1'));
                        $('input[autocomplete="shipping address-level2"]').val(getObjParam('locality') || getObjParam('administrative_area_level_2'));
                        $('input[autocomplete="shipping postal-code"]').val(getObjParam('postal_code'));

                        var compState = getObjParam('administrative_area_level_1', true);
                        var selectedState = $(`option[value="${compState}"]`, 'select[autocomplete="shipping address-level1"]');
                        if (selectedState.length) {
                            $('option', 'select[autocomplete="shipping address-level1"]').prop('selected', false);
                            selectedState.prop('selected', true);
                        }
                    } else {
                        // @TODO: Add error message?
                    }
                });
            },
            (err) => {
                $spinner.stop();
                // @TODO: Add error message?
                console.log(err);
            },
        );
    });

    $('body').on('click', '.add-new-address-button', () => {
        $('#editAddressForm').trigger('reset');
        $('.edit-address-wrapper', '#deliveryAddressModal').removeClass('d-none');
        $('.select-address-wrapper', '#deliveryAddressModal').addClass('d-none');

        $('.title-select-address', '#deliveryAddressModal').addClass('d-none');
        $('.title-edit-address', '#deliveryAddressModal').addClass('d-none');
        $('.title-add-address', '#deliveryAddressModal').removeClass('d-none');
    });

    $('#deliveryPickupModal').off('show.bs.modal').on('show.bs.modal', (e) => {
        $('#deliveryPickupModal .results').data('pids', e.relatedTarget.dataset.pids || '');
        $('#deliveryPickupModal .results').data('pid', e.relatedTarget.dataset.pid || '');
        $('#deliveryPickupModal .results').data('shipmentuuid', e.relatedTarget.dataset.shipmentuuid || '');
        $('#deliveryPickupModal .results').data('uuid', e.relatedTarget.dataset.uuid || '');

        $('#store-postal-code').val($('.delivery-rules .delivery-selected-zipcode').text().trim());
        $('#store-postal-code').closest('form.store-locator').trigger('submit');
    });

    $('#deliveryOptionModal').on('show.bs.modal', function () {
        const modal = $(this);
        modal.find('#delivery-zip-code').val('');
        modal.find('#deliveryOptionFeedback').addClass('d-none');
        modal.find('#deliveryOptionSwitchToPickup').addClass('d-none');
        modal.find('#deliveryOptionSubmit').prop('disabled', true);
        $('input[name="deliveryMethod"][value="delivery"]').prop('checked', true);
    });

    $('#delivery-zip-code').on('input', function () {
        const zipCode = $(this).val();
        const submitButton = $('#deliveryOptionSubmit');
        const feedback = $('#deliveryOptionFeedback');

        if (zipCode.length === 5 && /^\d+$/.test(zipCode)) {
            submitButton.prop('disabled', false);
        } else {
            submitButton.prop('disabled', true);
        }

        if (zipCode.length > 0 && zipCode.length < 5) {
            feedback.removeClass('d-none');
        } else {
            feedback.addClass('d-none');
        }
    });

    $('#deliveryOptionZipCodeForm').on('submit', function (e) {
        e.preventDefault();
        const form = $(this);
        const submitButton = form.find('#deliveryOptionSubmit');
        const feedback = form.find('#deliveryOptionFeedback');

        if (!submitButton.prop('disabled')) {
            submitButton.prop('disabled', true);
            feedback.addClass('d-none');

            $.spinner().start();

            // Check if we're on a PDP and get the product ID
            const isPDP = $('.product-detail').length > 0;
            let formData = form.serialize();

            if (isPDP) {
                formData += getDeliveryOptionsRequiredData(formData, '&');
            }

            $.ajax({
                url: form.attr('action'),
                type: 'POST',
                dataType: 'json',
                data: formData,
                success(data) {
                    if (data.success) {
                        if ($('.cart-page').length > 0) {
                            window.location.reload();
                            return;
                        }

                        $('.delivery-selected-zipcode').text(data.customerPostalCode);

                        if (data.deliveryOptions) {
                            $('body').trigger('delivery:updated', data.deliveryOptions);
                        }

                        $('#deliveryOptionModal').modal('hide');
                    } else {
                        $('#deliveryOptionSwitchToPickup').removeClass('d-none');
                        feedback.text(data.error);
                        feedback.removeClass('d-none');
                    }

                    $.spinner().stop();
                },
                error(err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $.spinner().stop();
                },
            });
        }
    });

    $('#deliveryOptionSwitchToPickup').on('click', () => {
        $('input[name="deliveryMethod"][value="pickup"]').prop('checked', true);
        updateAddToCartBasedOnDeliveryMethod();
    });

    // Handle delivery method selection changes
    $(document).on('change', 'input[name="deliveryMethod"]', () => {
        $('#product-info .quantity-select').trigger('change');
        updateAddToCartBasedOnDeliveryMethod();
    });

    // Handle product variation and quantity changes to update delivery options
    $('body').on('product:afterAttributeSelect', (e, response) => {
        if ($('.product-detail').length > 0 && $('.delivery-option-card').length > 0) {
            $('.product-detail').data('pid', response.data.product.id).attr('data-pid', response.data.product.id);
            $('.delivery-options-container a[data-pid]').data('pid', response.data.product.id).attr('data-pid', response.data.product.id);
            if (response.data && response.data.deliveryOptions) {
                $('body').trigger('delivery:updated', response.data.deliveryOptions);
            }
        }
    });

    $('body').on('delivery:updated', (ev, data) => {
        if (data) {
            const $deliveryCard = $('.delivery-option-card.delivery-card');
            const $pickupCard = $('.delivery-option-card.pickup-card');
            const $deliveryRadio = $deliveryCard.find('#deliveryMethod-delivery');
            const $pickupRadio = $pickupCard.find('#deliveryMethod-pickup');
            const $deliveryMessage = $deliveryCard.find('.js-delivery-message');
            const $pickupMessage = $pickupCard.find('.js-pickup-message');
            const $deliveryAvailability = $deliveryCard.find('.js-delivery-availability > div');
            const $pickupAvailability = $pickupCard.find('.js-pickup-availability > div');
            const $deliveryLocation = $deliveryCard.find('.delivery-location');
            const $pickupLocation = $pickupCard.find('.pickup-location');
            const $deliveryLabel = $deliveryCard.find('.js-delivery-label');
            const $deliveryLabelOutOfRange = $deliveryCard.find('.js-delivery-label-no-range');
            var isDeliverySelected = $deliveryRadio.is(':checked');
            var isPickupSelected = $pickupRadio.is(':checked');

            if (data.local.block) {
                $deliveryCard.addClass('unavailable');
                $deliveryLocation.addClass('d-none');
            } else {
                $deliveryCard.removeClass('unavailable');
                $deliveryLocation.removeClass('d-none');
            }

            if (data.pickup.block) {
                $pickupCard.addClass('unavailable');
                $pickupLocation.addClass('d-none');
            } else {
                $pickupCard.removeClass('unavailable');
                $pickupLocation.removeClass('d-none');
            }

            $deliveryRadio.data('available', data.local.isAvailable);
            $pickupRadio.data('available', data.pickup.isAvailable);

            $deliveryMessage.text(data.local.message ? data.local.message.text : '');
            $pickupMessage.text(data.pickup.message ? data.pickup.message.text : '');
            $deliveryAvailability.text(data.local.stockMessage ? data.local.stockMessage.text : '');
            $pickupAvailability.text(data.pickup.stockMessage ? data.pickup.stockMessage.text : '');

            $deliveryAvailability.removeClass().addClass(data.local.stockMessage ? data.local.stockMessage.classes : '');
            $pickupAvailability.removeClass().addClass(data.pickup.stockMessage ? data.pickup.stockMessage.classes : '');

            if (data.local.outOfDeliveryRange) {
                $deliveryLabel.addClass('d-none');
                $deliveryLabelOutOfRange.removeClass('d-none');
            } else {
                $deliveryLabel.removeClass('d-none');
                $deliveryLabelOutOfRange.addClass('d-none');
            }

            if (isDeliverySelected && data.local.block) {
                $deliveryRadio.prop('checked', false);
                isDeliverySelected = false;
                if (!data.pickup.block) {
                    $pickupRadio.prop('checked', true).trigger('change');
                    isPickupSelected = true;
                }
            } else if (isPickupSelected && data.pickup.block) {
                $pickupRadio.prop('checked', false);
                isPickupSelected = false;
                if (!data.local.block) {
                    $deliveryRadio.prop('checked', true).trigger('change');
                    isDeliverySelected = true;
                }
            }

            if (!isPickupSelected && data.local.movedToGround) {
                // Populate modal with data
                const groundDate = data.local.groundAvailableDate;
                const groundDateInDays = data.local.groundAvailableInDays || '7';
                const { bestStoreQuantity } = data.local;

                $('#deliveryUpdateModal .delivery-date').text(groundDate);
                $('#deliveryUpdateModal .delivery-date-days').text(groundDateInDays);
                $('#deliveryUpdateModal .available-quantity').text(bestStoreQuantity);
                $('#deliveryUpdateModal .js-reduce-quantity-estimate').text(data.local.nextDay ? 'tomorrow' : 'today');
                $('#deliveryUpdateModal .js-available-quantity').val(bestStoreQuantity);

                $('#deliveryUpdateModal #deliveryUpdateReduceQuantity').prop('checked', false);
                $('#deliveryUpdateModal #deliveryUpdateKeepAll').prop('checked', true);

                $('#deliveryUpdateModal').modal('show');
            }

            // Update Add to Cart button state after delivery options are updated
            updateAddToCartBasedOnDeliveryMethod();
        }
    });

    updateAddToCartBasedOnDeliveryMethod();

    $('body').on('change', 'input[name="deliveryUpdateChoice"]', () => {
        $('#deliveryUpdateModal .delivery-update-label').removeClass('selected');
        $('#deliveryUpdateModal input[name="deliveryUpdateChoice"]:checked').closest('.delivery-update-label').addClass('selected');
    });

    $('body').on('store:selected', () => {
        var $pickup = $('input[name="deliveryMethod"][value="pickup"]');
        if ($pickup.length && !$pickup.prop('checked')) {
            $pickup.prop('checked', true);
        }
        updateAddToCartBasedOnDeliveryMethod();
    });
});

module.exports = {
    getDeliveryOptionsRequiredData,
};
